import React, { useState, useEffect } from 'react';
import { useProperty } from '../context/PropertyContext';
import PropertyCard from './PropertyCard';

const PropertiesSection = ({ searchResults }) => {
  const { properties } = useProperty();
  const [filteredProperties, setFilteredProperties] = useState([]);

  useEffect(() => {
    // Use search results if available, otherwise use all properties
    const propertiesToShow = searchResults || properties;
    setFilteredProperties(propertiesToShow);
  }, [properties, searchResults]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="properties" className="properties-luxhom">
      <div className="container">
        <div 
          className="section-header-luxhom"
        >
          <div className="section-badge-luxhom">
            {searchResults ? 'SEARCH RESULTS' : 'FEATURED PROPERTIES'}
          </div>
          <h2>{searchResults ? 'Search Results' : 'Luxury Properties Collection'}</h2>
          <p>
            {searchResults 
              ? `Discover ${filteredProperties.length} exceptional properties matching your search criteria`
              : 'Explore our carefully curated selection of the world\'s most prestigious luxury properties'
            }
          </p>
        </div>

        <div className="properties-grid-luxhom">
          {filteredProperties.length > 0 ? (
            filteredProperties.map((property, index) => (
              <PropertyCard 
                key={property.id} 
                property={property} 
                index={index}
              />
            ))
          ) : (
            <div 
              className="no-properties"
            >
              <div className="no-properties-content">
                <i className="fas fa-search"></i>
                <h3>No Properties Found</h3>
                <p>We couldn't find any properties matching your search criteria. Try adjusting your filters or browse our complete collection.</p>
                <button 
                  className="btn-luxhom"
                  onClick={() => {
                    window.location.reload(); // Reset search
                    scrollToTop();
                  }}
                >
                  <span>View All Properties</span>
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PropertiesSection;